import { useCallback, useEffect, useState } from "react";
import { SubscriptionTier } from "../../proto/api_pb";
import { SubscriptionContentContainer } from "./styles";
import { Chip } from "@mui/material";
import { APP_COLOR, APP_HOVER_COLOR } from "../../theme";

interface SubscriptionContentProps {
  subscriptionTier: number;
}

export const SubscriptionContent: React.FC<SubscriptionContentProps> = ({
  subscriptionTier,
}) => {
  const [content, setContent] = useState<string>("");

  const checkContent = useCallback(() => {
    if (subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_PRO) {
      setContent("PRO");
    } else if (subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_MAJOR) {
      setContent("MAJOR");
    } else if (subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_STUDIO) {
      setContent("STUDIO");
    } else if (subscriptionTier === SubscriptionTier.SUBSCRIPTION_TIER_MINOR) {
      setContent("MINOR");
    } else {
      setContent("");
    }
  }, [subscriptionTier]);

  useEffect(() => {
    checkContent();
  }, [checkContent]);

  return (
    <SubscriptionContentContainer>
      {content && (
        <Chip
          label={content}
          size="small"
          sx={{
            fontSize: 12,
            backgroundColor:
              content === "MINOR"
                ? "gray"
                : content === "MAJOR"
                ? APP_COLOR
                : APP_HOVER_COLOR,
          }}
        />
      )}
    </SubscriptionContentContainer>
  );
};
